import classNames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';

import styles from './Filters.module.css';

function getOption(o) {
  let label, value;

  if (Object.prototype.hasOwnProperty.call(o, 'value')) {
    label = o.label;
    value = o.value;
  } else {
    label = o;
    value = o;
  }

  return (
    <option key={value} value={value}>
      {label}
    </option>
  );
}

function filtersUnset(filters) {
  if (filters.state) {
    return false;
  }

  if (filters.administration) {
    return false;
  }

  return true;
}

// TODO: Try maintaining filter state upstream and just passing in as props.
function Filters({ options, filters, onChangeFilters }) {
  const filterContainer = React.createRef();
  const handleFilterChange = evt => onChangeFilters(evt.target);

  if (!options.state) {
    return null;
  }

  const filterClassNames = {
    state:
      filters.state === '' || filters.state === undefined
        ? styles.State
        : classNames(styles.State, styles.filtered),
    administration:
      filters.administration === '' || filters.administration === undefined
        ? styles.Administration
        : classNames(styles.Administration, styles.filtered),
  };

  return (
    <form className={styles.Filters} ref={filterContainer}>
      <div className={styles.Inner}>
        <div className={styles.Row}>
          <select
            className={filterClassNames.state}
            id="select-state"
            name="state"
            value={filters.state}
            onChange={handleFilterChange}
          >
            <option value="">Filter state</option>
            {options.state.map(getOption)}
          </select>

          <select
            className={filterClassNames.administration}
            id="select-administration"
            name="administration"
            value={filters.administration}
            onChange={handleFilterChange}
          >
            <option value="">Filter Administration</option>
            {options.administration.map(getOption)}
          </select>

          <input
            type="reset"
            id="show-all"
            name="show-all"
            value="Show All"
            disabled={filtersUnset(filters)}
            onClick={handleFilterChange}
          />
          <label htmlFor="show-all">Show All</label>
        </div>
      </div>
    </form>
  );
}

Filters.defaultProps = {
  options: {},
  defaultFilters: {},
};

Filters.propTypes = {
  options: PropTypes.shape({
    state: PropTypes.arrayOf(PropTypes.string),
    administration: PropTypes.arrayOf(PropTypes.string),
  }),
  filters: PropTypes.shape({
    state: PropTypes.string,
    administration: PropTypes.string,
  }),
  onChangeFilters: PropTypes.func.isRequired,
};

export default Filters;
